import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {IRegion} from "app/shared/model/region.model";

export interface ISymptom {
  id?: string;
  emergencyType?: EmergencyType;
  enCondition?: string;
  stCondition?: string;
  requiredFacilityLevel?: number;
  requiredVehicleLevel?: number;
  requiredFacilityLevel2?: number;
  displayOrder?: number;
  country?: IRegion;
  isActive?: boolean;
}

export const defaultValue: Readonly<ISymptom> = {};
